// Durable "Auto-assigned" marker. The bids panel only renders while a
// booking's bid window is open, so this badge — placed beside the vendor/
// crew name in carVendorSection — is what tells ops, after the fact, that
// the advertised crew won its own listing at window close with no lower
// bid from another local crew.
export function AssignmentBadge({ assignedBy }: { assignedBy: 'auto_assign' | null }) {
  if (assignedBy !== 'auto_assign') return null;

  return (
    <span className="ms-2 inline-flex items-center rounded-full bg-[color:var(--bo-accent)]/10 px-2 py-0.5 text-[10.5px] font-semibold text-[color:var(--bo-accent)]">
      Auto-assigned
    </span>
  );
}
